import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import { CountdownTimer } from 'src/components/Chicken/ui/countdown-timer/CountdownTimer'
import common from 'src/styles/common.module.scss'
import styles from './styles.module.scss'

export const TextHeaderRo = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <div className={styles.wrapper_content}>
            <HighlightedText
                text="Ghicește unde sunt banii."
                highlights={[
                    { word: 'Ghicește' },
                    { word: 'unde' },
                    { word: 'sunt' },
                    { word: 'banii.' },
                ]}
                breakAfterWords={isDesktop ? [] : ['unde']}
                className={common.text_header}
            />
            <div className={styles.wrapper}>
                <span className={styles.text}>Ai trei încercări!</span>
                <CountdownTimer />
            </div>
        </div>
    )
}
